import { ReactElement } from 'react'
import { Button } from '@mui/material'
import { UseMutationResult } from '@tanstack/react-query'
import { SaveButton } from '@ui/actions'
import { DialogBase } from '@ui/feedback'
import AssemblyForm from '../AssemblyForm'
import { getAllowedUsageTypesForDuplication } from '../utils/duplicateAssembly'

const FORM_ID = 'assembly-create-form'

interface Props {
  open: boolean
  onClose: () => void
  assembly: Assembly
  mutation: UseMutationResult<CLTAssembly | TimberFrameAssembly, unknown, Assembly, unknown>
  earthMassForce: number
}

const EditAssemblyDialog = ({
  open,
  onClose,
  assembly,
  mutation,
  earthMassForce,
}: Props): ReactElement => {
  const handleSubmit = async (data: Assembly) => {
    await mutation.mutateAsync(data)
    onClose()
  }

  // For edit: restrict to compatible usage types based on the assembly's current usage_type
  const allowedUsageTypes = getAllowedUsageTypesForDuplication(assembly.usage_type)

  return (
    <DialogBase
      open={open}
      onClose={onClose}
      title={`${assembly.name} editieren`}
      dialogProps={{
        maxWidth: 'lg',
        fullWidth: true,
      }}
    >
      <>
        <AssemblyForm
          defaultValues={assembly}
          id={FORM_ID}
          onSubmit={handleSubmit}
          earthMassForce={earthMassForce}
          allowedUsageTypes={allowedUsageTypes}
        />
      </>
      <>
        <Button onClick={onClose}>Abbrechen</Button>
        <SaveButton
          loading={mutation.isLoading}
          form={FORM_ID}
          type="submit"
          data-cy="save-assembly"
        >
          Speichern
        </SaveButton>
      </>
    </DialogBase>
  )
}

export default EditAssemblyDialog
